import { GraphQL, GraphQLPagedQueryData } from "@rpi/openapi-api";
import { Flex } from "@rpi/openapi-core";
import React from "react";
import { FieldInfoTooltip } from "../../../components/FieldInfoTooltip";
import { createRpaTableMenuColumn } from "../../../components/RpaTableMenu";
import { ApiCredentialColumn } from "../../../configuration/columns/apiCredential.column";
import { RpiTableAdditionalColumns, RpiTableColumns } from "../../../rpi-core/table/RpiTable";
import { createEntityColumn } from "../../../rpi-core/table/RpiTableHelpers";
import { EnableDisableAction } from "./EnableDisableAction";
import { KeyStatusBadge } from "./KeyStatusBadge";

const apiCredentialColumn = createEntityColumn<GraphQL.ApiCredentialsResponse, GraphQL.ApiCredentialSearchFields>();

const statusColumn = apiCredentialColumn<"status">({
  header: "Key Status",
  accessor: "status",
  cell: ({ row }) => <KeyStatusBadge status={row.status} />,
  size: 140,
});

const webhookSecretColumn = {
  ...ApiCredentialColumn.webhookSecret,
  header: (
    <Flex.Row align="center" gap={4}>
      Webhook Secret
      <FieldInfoTooltip label="Webhook Secret" content="Each organization can only have one Webhook Secret." />
    </Flex.Row>
  ),
};

// The design labels this column "Key Description"; the legacy view keeps its own "Description".
const keyDescriptionColumn = {
  ...ApiCredentialColumn.description,
  header: "Key Description",
};

// Columns per the Developer Tools design: Key Status sits beside the API key, and the raw
// Shared Secret column is omitted — the Authorization Header column already encodes it.
export const apiKeysColumns: RpiTableColumns<GraphQLPagedQueryData<GraphQL.ApiCredentialsQuery>> = (user) => [
  user.is.SUPER_ADMIN && ApiCredentialColumn.customer,
  webhookSecretColumn,
  ApiCredentialColumn.apiKey,
  statusColumn,
  ApiCredentialColumn.authHeader,
  keyDescriptionColumn,
];

// Trailing kebab-menu column holding the Enable/Disable action (confirm dialog + toasts).
export const apiKeysMenuColumns: RpiTableAdditionalColumns<GraphQLPagedQueryData<GraphQL.ApiCredentialsQuery>> = [
  createRpaTableMenuColumn((row) => <EnableDisableAction id={row.id} status={row.status} />),
];
